import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const customStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:wght@400;500&display=swap');
`;

export default function RefundPolicy() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = customStyles;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0f1c 0%, #0d1525 100%)',
      fontFamily: "'DM Sans', sans-serif",
      color: 'white'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(255,255,255,0.02)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        padding: '20px 40px'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px'
            }}>
              ⚡
            </div>
            <span style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: '18px',
              fontWeight: '600',
              color: 'white'
            }}>
              BrainForge
            </span>
          </Link>
          <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
        </div>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '60px 40px'
      }}>
        <h1 style={{
          fontFamily: "'Outfit', sans-serif",
          fontSize: '40px',
          fontWeight: '700',
          marginBottom: '12px'
        }}>
          Refund Policy
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: '48px' }}>
          Last updated: December 2025
        </p>

        <div style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderRadius: '16px',
          padding: '32px'
        }}>
          {[
            {
              title: '1. Free Trial',
              content: 'We offer a 7-day free trial for all new users. No credit card is required to start your trial. You can cancel at any time during the trial period without being charged.'
            },
            {
              title: '2. Subscription Refunds',
              content: 'If you are unsatisfied with your subscription, you may request a refund within 14 days of your initial purchase or renewal. Refund requests after 14 days will be reviewed on a case-by-case basis.'
            },
            {
              title: '3. How to Request a Refund',
              content: 'To request a refund, please contact us at support@multipowerai.com with your account email and reason for the refund. We aim to process refund requests within 5 business days.'
            },
            {
              title: '4. Third-Party API Costs',
              content: 'We cannot refund charges incurred from third-party AI providers (Anthropic, OpenAI, xAI, DeepSeek). These charges are billed directly to you by the providers based on your API key usage.'
            },
            {
              title: '5. Cancellation',
              content: 'You can cancel your subscription at any time from your Settings page. Upon cancellation, you will retain access until the end of your current billing period.'
            },
            {
              title: '6. Prorated Refunds',
              content: 'We do not offer prorated refunds for partial months or years. If you cancel, your access continues until the end of your billing period.'
            },
            {
              title: '7. Account Termination',
              content: 'We reserve the right to terminate accounts that violate our Terms of Service. In cases of termination for policy violations, refunds are not provided.'
            },
            {
              title: '8. Contact Us',
              content: 'For refund requests or billing questions, please contact support@multipowerai.com. We\'re here to help!'
            }
          ].map((section, i) => (
            <div key={i} style={{ marginBottom: i < 7 ? '28px' : 0 }}>
              <h2 style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: '18px',
                fontWeight: '600',
                color: '#667eea',
                marginBottom: '12px'
              }}>
                {section.title}
              </h2>
              <p style={{
                color: 'rgba(255,255,255,0.7)',
                lineHeight: '1.7',
                fontSize: '15px'
              }}>
                {section.content}
              </p>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: '40px',
          display: 'flex',
          gap: '24px',
          justifyContent: 'center'
        }}>
          <Link to="/terms" style={{ color: '#667eea', textDecoration: 'none', fontSize: '14px' }}>
            Terms of Service
          </Link>
          <Link to="/privacy" style={{ color: '#667eea', textDecoration: 'none', fontSize: '14px' }}>
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
